import { bool, func } from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@olist/design-system';
import { Box, Text } from '@olist/united';

import {
  ARTICLE_ALLOWED_MEASURES,
  ARTICLE_BANK_ACCOUNT,
  ARTICLE_XML_INVOICE,
} from '../../../../utils/external-urls';

const RequisitesQuestionsModal = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onRequestClose}
      title={t`questions about requirements`}
      size="small"
      body={
        <div>
          <Box>
            <Text fontWeight="bold">{t`state linked to the company's CNPJ`}</Text>
            <Trans i18nKey="allowStates">
              <Text color="foundation.neutralStronger" fontSize={1}>
                we serve companies in the states of SP, RJ, ES, MG, PR, SC, RS, BA and we are
                working to cover other regions soon. If your logistics address is outside these
                areas, use our Tiny solution to sell more on marketplaces.
              </Text>
            </Trans>
          </Box>

          <Box mt={5}>
            <Text fontWeight="bold">{t`pj bank account associated with cnpj`}</Text>
            <Trans i18nKey="canReceive">
              <Text color="foundation.neutralStronger" fontSize={1}>
                the payment of sales depends on the company having an exclusive bank account for the
                registered CNPJ.
                <Text.Link
                  href={ARTICLE_BANK_ACCOUNT}
                  target="_blank"
                  data-ref="know-more-link"
                  fontSize={1}
                >
                  read more about pj bank account
                </Text.Link>
              </Text>
            </Trans>
          </Box>
          <Box mt={5}>
            <Text fontWeight="bold">{t`issue the electronic invoice`}</Text>
            <Trans i18nKey="digitalNfe">
              <Text color="foundation.neutralStronger" fontSize={1}>
                it is mandatory to sell in any marketplace. the digital note with the 44-digit
                access key is sent with the product to prove the sale.
              </Text>
              <Text color="foundation.neutralStronger" fontSize={1}>
                <b>important:</b> the note must be issued by the same registered CNPJ.{' '}
                <Text.Link
                  href={ARTICLE_XML_INVOICE}
                  target="_blank"
                  data-ref="know-more-link"
                  fontSize={1}
                >
                  understand how nfe emission works
                </Text.Link>
              </Text>
            </Trans>
          </Box>
          <Box mt={5}>
            <Text fontWeight="bold">{t`packages within the permitted measures`}</Text>
            <Trans i18nKey="packageMeasures">
              <Text color="foundation.neutralStronger" fontSize={1}>
                our exclusive contract with partner carriers is available for all orders and the
                packaging dimensions (package with the product inside) must be within the following
                limit: 100 cm X 100 cm X 100 cm, 30 kg.{' '}
                <Text.Link
                  href={ARTICLE_ALLOWED_MEASURES}
                  target="_blank"
                  data-ref="know-more-link"
                  fontSize={1}
                >
                  see more about allowed measures
                </Text.Link>
              </Text>
            </Trans>
          </Box>
        </div>
      }
    />
  );
};

RequisitesQuestionsModal.propTypes = {
  isOpen: bool.isRequired,
  onRequestClose: func.isRequired,
};

export default RequisitesQuestionsModal;
